<template>
    <modal
        :name="'renovar-' + abonado.id"
        transition="pop-out"
        :width="1000"
        height="auto"
        :scrollable="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Renovación rápida</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <template v-if="continuar == false">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-3">
                                <p>NÚM. ABONADO ANTERIOR: <span class="text-primary h5">{{ abonado.n_abonado_antiguo }}</span></p>
                            </div>
                            <div class="col-3">
                                <p>NÚM. ABONADO NUEVO: <br> <span class="text-primary h5">{{ abonado.n_abonado }}</span></p>
                            </div>
                            <div class="col-6">
                                <p>
                                    ZONA:<br>
                                    <span class="text-primary h5">{{ abonado.asiento.region }} / FILA: {{ abonado.asiento.row }} / BUTACA: {{ abonado.asiento.seat }}</span>
                                </p>
                            </div>
                            <div class="col-12">
                                <strong>DATOS PERSONALES</strong>
                                <hr class="mt-1">
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-4">
                                        <FormInput label="Nombre" name="nombre" id="nombre" rules="required" v-model="abonado.name" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Apellidos" name="apellidos" id="apellidos" rules="required" v-model="abonado.surnames" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Dni" name="dni" id="dni" rules="required" v-model="abonado.dni" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Fecha de nacimiento" name="fecha_nacimiento" id="fecha_nacimiento" rules="required" type="date" min="1900-01-01" v-model="abonado.fecha_nacimiento" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Email" name="email" id="email" rules="required" v-model="abonado.email" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Teléfono" name="telefono" id="telefono" rules="required" v-model="abonado.telefono" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Provincia" name="provincia" id="provincia" rules="required" v-model="abonado.provincia" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Localidad" name="localidad" id="localidad" rules="required" v-model="abonado.localidad" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Domicilio" name="domicilio" id="domicilio" rules="required" v-model="abonado.domicilio" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <strong>DATOS SOBRE EL ABONO</strong>
                                <hr class="mt-1">
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-4">
                                         <div class="form-group">
                                            <label for="area">Tipo de abono</label>
                                            <ValidationProvider name="area" rules="required" v-slot="{ errors }">
                                                <select name="area" v-model="abonado.area" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')">
                                                    <template v-for="(precio, index) in precios">
                                                        <option :key="index" :value="precio"> <span v-if="precio.renovacion">(Renovación) - </span>{{ precio.descripcion }}</option>
                                                    </template>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="precio">Precio</label>
                                            <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                                                <select name="precio" v-model="abonado.precio" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')">
                                                    <template v-for="(descuento, index) in precios_abono">
                                                        <option :key="index" :value="descuento">{{ descuento.label }}</option>
                                                    </template>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="metodo_pago">Método de pago</label>
                                            <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="descuento" v-model="abonado.metodo_pago">
                                                    <option value="0">Seleccione un metodo de pago</option>
                                                    <template v-for="(metodo, index) in metodos_pago">
                                                        <option :key="index" :value="metodo">{{ metodo.texto }}</option>
                                                    </template>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="descuento">Descuento</label>
                                            <ValidationProvider name="descuento_total" rules="required" v-slot="{ errors }">
                                                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="descuento" v-model="abonado.descuento_aplicado">
                                                    <option value="0">Sin descuento</option>
                                                    <template v-for="(descuento, index) in configuracion.descuento_aplicado">
                                                        <option :key="index" :value="descuento.valor">{{ descuento.label }}</option>
                                                    </template>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Peña/Empresa" id="empresa" v-model="abonado.penista" />
                                    </div>
                                    <div v-if="is_domiciliado == true" class="col-4">
                                        <FormInput label="IBAN" id="iban" rules="required" v-model="abonado.iban" />
                                    </div>
                                    <div v-if="is_domiciliado == true" class="col-4">
                                        <FormInput label="Titular de la cuenta" id="titular_cuenta" rules="required" v-model="abonado.titular_cuenta" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="observaciones">Observaciones</label>
                                    <textarea class="form-control" rows="3" placeholder="Observaciones..." v-model="abonado.observaciones"></textarea>
                                </div>
                            </div>
                            <div class="col-12" v-if="abonado.metodo_pago && abonado.metodo_pago.valor == 9">
                                <FormInput label="IBAN" name="IBAN" rules="required" v-model="abonado.iban" />
                                <FormInput label="Titular de la cuenta" name="Titular de la cuenta" rules="required" v-model="abonado.titular_cuenta" />
                            </div>
                            <div class="col-12">
                                <Button type="submit">Renovar</Button>
                            </div>
                        </div>
                    </div>
                </ValidationObserver>
                <div class="card-footer text-right">
                    <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
                </div>
            </template>
            <template v-else>
                <div class="card-body">
                    <div class="row">
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <strong>DATOS DEL ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-user"></i></span> <strong> {{ abonado.name }} {{ abonado.surnames }}</strong></span>
                                    <hr>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-id-card"></i></span> <strong> {{ abonado.dni }}</strong></span>
                                    <hr>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-envelope"></i></span> <strong> {{ abonado.email }}</strong></span>
                                    <hr>
                                </div>

                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-phone"></i></span> <strong> {{ abonado.telefono }}</strong></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <strong>INFORMACIÓN DEL ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h4 text-uppercase text-primary"><strong>{{ abonado.asiento.region }}</strong></span>
                                    <span class="h4 text-uppercase"><strong>/ FILA: {{ abonado.asiento.row }}</strong></span>
                                    <span class="h4 text-uppercase"><strong>/ BUTACA: {{ abonado.asiento.seat }}</strong></span>
                                </div>
                                <div class="col-12 mt-3">
                                    <strong>TIPO DE ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h4 text-uppercase"><strong>{{ abonado.precio.descripcion }}</strong></span>
                                </div>
                                <div class="col-12 mt-3">
                                    <strong>FORMA DE PAGO SELECCIONADA</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h4 text-uppercase"><strong>{{ abonado.metodo_pago.texto }}</strong></span>
                                </div>
                                <div class="col-12 mt-3">
                                    <template v-if="! abonado.plazos">
                                        <strong>PRECIO ABONO <span> <span v-if="abonado.descuento_aplicado > 0" class="text-primary">(DESCUENTO DEL {{ abonado.descuento_aplicado }}%)</span></span></strong>
                                    </template>
                                    <template v-else>
                                        <div class="col-12 mt-3">
                                            <strong>PLAZOS:</strong>
                                        </div>
                                        <div class="col-12">
                                            <ul>
                                                <template v-for="(plazo, key) in abonado.plazos_pendientes">
                                                    <li :key="key">
                                                        <template v-if="plazo.gastos_internos == 0">
                                                            Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe + plazo.gastos  | formatear_precio }}
                                                        </template>
                                                        <template v-else>
                                                            Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe  | formatear_precio }}
                                                        </template>                                            
                                                    </li>
                                                </template>                                
                                            </ul>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-12">
                                    <span class="h4"><strike><strong v-if="abonado.descuento_aplicado > 0">{{ abonado.precio.precio_total_taquilla | formatear_precio }}</strong></strike></span>
                                    <template v-if="! abonado.plazos">
                                        <strong>TOTAL:</strong><span class="h1"> <strong> {{ totalConDescuento(abonado.precio.precio_total_taquilla, abonado.descuento_aplicado) | formatear_precio }}</strong></span>
                                    </template>
                                    <template v-else>
                                        <strong>TOTAL:</strong><span class="h1"> <strong> {{ totalConDescuento(abonado.plazos_pendientes[0].importe, abonado.descuento_aplicado) | formatear_precio }}</strong></span>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-12"><hr></div>

                        <div class="col-12" v-if="!loading">
                            <template v-if="! abonado.plazos">
                                <strong>TOTAL:</strong><span class="h1"> <strong> {{ totalConDescuento(abonado.precio.precio_total_taquilla, abonado.descuento_aplicado) | formatear_precio }}</strong></span>
                            </template>
                            <template v-else>
                                <strong>TOTAL:</strong><span class="h1"> <strong> {{ totalConDescuento(abonado.plazos_pendientes[0].importe, abonado.descuento_aplicado) | formatear_precio }}</strong></span>
                            </template>
                            

                            <template v-if="!finalizado">
                                <Button class="float-right" @click.prevent="finalizarCompra()">COMPRAR</Button>
                                <Button class="float-right mr-3" @click.prevent="volver">EDITAR</Button>
                            </template>                            
                            <div class="alert alert-success alert-dismissible mt-3" v-else>
                                <h5><i class="icon fas fa-check mt-2"></i> {{ mensaje }} <Button :href="url_imprimir" class="btn-large float-right" target="_blank">Imprimir abono</Button> <Button :href="url_factura" class="btn-large float-right mr-2" target="blank_">Imprimir recibo</Button></h5>
                            </div>
                        </div> 
                        <div v-else class="col-12" style="height: 100px">
                            <LoaderComponent></LoaderComponent>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
                </div>
            </template>
        </div>
    </modal>
</template>

<script>

    export default {
        props: ['abonado', 'precios'],
        data() {
            return {
                metodos_pago : [
                    { valor : 1, texto : 'METÁLICO' },
                    { valor : 3, texto : 'DATÁFONO' },
                    { valor : 4, texto : 'TRANSFERENCIA' },
                    { valor : 7, texto : 'DOMICILIADO' }
                ],
                continuar: false,
                finalizado: false,
                loading: false,
                url_imprimir: null,
                url_factura: null,
                mensaje: null
            }
        },
        created() {
            this.abonado.descuento_aplicado = 0;
            if(this.teatro.permitir_plazos_abonados == 1) {
                this.metodos_pago.push({ valor : 9, texto : 'A PLAZOS' });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            precios_abono() {
                return this.abonado.area ? this.abonado.area.descuentos : [];
            },
            is_domiciliado() {
                if (!this.abonado.metodo_pago) {
                    return false
                }
                return this.abonado.metodo_pago.valor == 5 ? true : false;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            volver() {
                this.continuar = false;
            },
            close() {
                this.$emit('close', 'renovar-' + this.abonado.id);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    if(this.abonado.metodo_pago.valor == 9) {
                        this.setPlazos();
                    } else {
                        this.resetPlazos();
                    }
                    this.continuar = true;
                }
            },
            setPlazos() {
                var plazos = [];
                this.abonado.plazos = true;

                var precio_reserva = 50;
                var numero_plazos = 2;
                var precio = this.abonado.precio.precio;

                plazos.push({
                    importe: precio_reserva,
                    gastos: this.abonado.precio.price_management_taquilla,
                    gastos_internos: this.abonado.precio.price_management_taquilla_interno,
                    pagado: 0,
                    fecha_pago: null,
                    informacion: 'Reserva de asiento'
                });

                var importe_restante = precio - precio_reserva;
                var importe_plazos = importe_restante / numero_plazos;

                var infos = ['5 Agosto', '6 Septiembre'];

                for (var i = 0; i < numero_plazos; i++) { 
                    plazos.push({
                        importe: importe_plazos,
                        gastos: 0,
                        gastos_internos: this.abonado.precio.price_management_taquilla_interno,
                        pagado: 0,
                        fecha_pago: null,
                        informacion: infos[i]
                    });
                }

                this.abonado.plazos_pendientes = plazos;
            },
            resetPlazos() {
                this.abonado.plazos = false;
                this.abonado.plazos_pendientes = [];
            },
            totalConDescuento (precio, descuento) {
                var desc = (descuento / 100) * precio;
                return precio - desc;
            },
            finalizarCompra() {
                this.loading = true;

                this.abonado.asiento.zona_id = this.abonado.asiento.region_id;
                this.abonado.asiento.asiento = this.abonado.asiento.seat;
                this.abonado.asiento.fila = this.abonado.asiento.row;

                const params = {
                    filters: {
                        abonado_id: this.abonado.id
                    },
                    data_abonado: this.abonado,
                    metodo_pago: {
                        id: this.abonado.metodo_pago.valor
                    },
                    asiento: this.abonado.asiento,
                    abonado_id: this.abonado.id,
                    precio_lista_abonado: this.abonado.area,
                    descuento_edad: this.abonado.precio,
                    descuento_aplicado: {
                        valor: this.abonado.descuento_aplicado
                    }

                };


                this.$store.dispatch(this.config.getVuexAlias('back.abonados.renovar'), params).then(res => {
                    this.finalizado = true;
                    this.mensaje = res.data.message;
                    this.url_imprimir = res.data.url_imprimir;
                    this.url_factura = res.data.url_factura;
                }).finally(() => this.loading = false);
            }
        },
    }
</script>
